import { render, staticRenderFns } from "./RecordingTreeItem.vue?vue&type=template&id=6adb0fed&"
import script from "./RecordingTreeItem.vue?vue&type=script&lang=js&"
export * from "./RecordingTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports